import React, { useState, useEffect } from "react";
import { dashboard } from "../../../api/Dashboard";
import PrimaryButton from "../../shared/Buttons/PrimaryButton";
// import AddToCartButton from "../../shared/Buttons/AddToCartButton"; // Commented out - shop feature disabled
import CheckoutBox from "./CheckoutBox";
import LoginSignupModal from "../../shared/LoginSignupModal/LoginSignupModal";
// import ProductItems from "./ProductItems"; // Commented out - shop feature disabled
// import PetProductItems from "./PetProductItems"; // Commented out - shop feature disabled
// import MerchandiseItems from "./MerchandiseItems"; // Commented out - shop feature disabled
import DonationItems from "./DonationItems";
import OrderSummary from "./OrderSummary";
import { useSelector, useDispatch } from "react-redux";
import { cartActions } from "../../../store/index";
import Spinner from "../../shared/LoadingSpinner/Spinner";
import EditDonationModal from "./EditDonationModal";
// import EditProductModal from "./EditProductModal"; // Commented out - shop feature disabled
// import SuccessModal from "../../shared/SuccessModal/SuccessModal"; // Commented out - shop feature disabled
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
// import WishlistButton from "../Wishlist/WishlistButton"; // Commented out - shop feature disabled
// import { getShopItems } from "../../../api/ShopItems"; // Commented out - shop feature disabled
import { Link } from "react-router-dom";
// import { resolveProductType } from "../../../utils/productType"; // Commented out - shop feature disabled

function Cart() {
  const [localUserData, setLocalUserData] = useState(null);
  const [shippingFee, setShippingFee] = useState(2.0);
  const [tax, setTax] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoginSignupModalOpen, setLoginSignupModalOpenModalOpen] =
    useState(false);
  const [loginOrSignup, setLoginOrSignup] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // States for donations
  const [donationItems, setDonationItems] = useState([]);
  const [donationTotal, setDonationTotal] = useState(0);
  const [editDonationsModal, setEditDonationsModal] = useState(false);
  const [editedDonation, setEditedDonation] = useState(null);
  const [updatedDonationAmount, setUpdatedDonationAmount] = useState(0);
  const [updatedDonationAmountError, setUpdatedDonationAmountError] =
    useState("");

  // States for products - commented out, shop feature disabled
  // const [productItems, setProductItems] = useState(null);
  // const [petProductItems, setPetProductItems] = useState([]);
  // const [merchandiseItems, setMerchandiseItems] = useState([]);
  // const [productTotal, setProductTotal] = useState(0);
  // const [petProductTotal, setPetProductTotal] = useState(0);
  // const [merchandiseTotal, setMerchandiseTotal] = useState(0);
  // const [editProductModal, setEditProductModal] = useState(false);
  // const [editedProduct, setEditedProduct] = useState(null);
  // const [updatedProduct, setUpdatedProduct] = useState(null);
  // const [updatedProductError, setUpdatedProductError] = useState("");

  // Related products state - commented out, shop feature disabled
  // const [relatedProducts, setRelatedProducts] = useState([]);
  // const [currentRelatedSlide, setCurrentRelatedSlide] = useState(0);
  // const [showModal, setShowModal] = useState(false);

  const cart = useSelector((state) => state.cart);
  const userData = useSelector((state) => state.userData.userData);
  const dispatch = useDispatch();

  // Set localUserData from Redux userData (fallback)
  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      setLocalUserData(JSON.parse(userData));
    }
  }, [userData]);

  // Removes the overflow for the background when edit modals are open
  useEffect(() => {
    if (editDonationsModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [editDonationsModal]);

  // Fetches donations from global state
  useEffect(() => {
    setDonationItems(cart.donations);

    // Product filtering/normalization commented out - shop feature disabled
    // const validProducts =
    //   cart.products?.filter((item) => {
    //     const price = parseFloat(item.variant_price) || 0;
    //     const fallbackPrice =
    //       parseFloat(item.first_price || item.sales_price) || 0;
    //     return price > 0 || fallbackPrice > 0;
    //   }) || [];
    // if (validProducts && validProducts.length > 0) {
    //   const normalizedProducts = validProducts.map((item) => {
    //     const resolvedType = resolveProductType(item);
    //     if (item.product_type === resolvedType) { return item; }
    //     return { ...item, product_type: resolvedType };
    //   });
    //   setProductItems(normalizedProducts);
    //   const petProducts = normalizedProducts.filter((item) => item.product_type === "pet_product");
    //   const merchandise = normalizedProducts.filter((item) => item.product_type === "merchandise");
    //   setPetProductItems(petProducts);
    //   setMerchandiseItems(merchandise);
    // } else {
    //   setProductItems([]);
    //   setPetProductItems([]);
    //   setMerchandiseItems([]);
    // }
  }, [cart.donations]);

  // Load related products - commented out, shop feature disabled
  // useEffect(() => {
  //   const fetchRelatedProducts = async () => {
  //     try {
  //       const response = await getShopItems();
  //       if (response && Array.isArray(response)) {
  //         const filtered = response.filter((item) => item.visible);
  //         const shuffled = filtered.sort(() => 0.5 - Math.random());
  //         setRelatedProducts(shuffled.slice(0, 4));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching related products:", error);
  //     }
  //   };
  //   fetchRelatedProducts();
  // }, []);

  // Opens the login/signup modal depending on the type
  const openLoginSignupModal = (type) => {
    setLoginOrSignup(type);
    setLoginSignupModalOpenModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  // Closes the login/signup modal
  const closeLoginSignupModal = () => {
    setLoginSignupModalOpenModalOpen(false);
    document.body.style.overflow = "";
  };

  // Refreshes the page after a user successfully signs up/logins
  const handleFormSuccess = (success) => {
    if (success) {
      window.location.reload();
    }
  };

  // Gets localUserData and sets isloading to false
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDataString = localStorage.getItem("userData");
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          const response = await dashboard(userData.id);
          setLocalUserData(response);

          localStorage.setItem("userData", JSON.stringify(response));
        }
        setIsLoading(false);
      } catch (error) {
        console.error(
          "Failed to parse user data or fetch user profile: ",
          error
        );
        localStorage.removeItem("userData");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("accessToken");
      }
    };

    fetchUserData();
  }, []);

  // Product total useEffects commented out - shop feature disabled
  // useEffect(() => {
  //   if (productItems?.length > 0) {
  //     const newProductTotal = productItems.reduce((acc, item) => {
  //       const price = parseFloat(item.variant_price) || 0;
  //       const adjustedPrice = item.product_type === "pet_product" ? price : price / 100;
  //       return acc + adjustedPrice * item.quantity;
  //     }, 0);
  //     setProductTotal(newProductTotal);
  //   } else { setProductTotal(0); }
  // }, [productItems]);
  // useEffect(() => {
  //   if (petProductItems?.length > 0) {
  //     const newPetProductTotal = petProductItems.reduce((acc, item) => {
  //       const price = parseFloat(item.variant_price) || 0;
  //       return acc + price * item.quantity;
  //     }, 0);
  //     setPetProductTotal(newPetProductTotal);
  //   } else { setPetProductTotal(0); }
  // }, [petProductItems]);
  // useEffect(() => {
  //   if (merchandiseItems?.length > 0) {
  //     const newMerchandiseTotal = merchandiseItems.reduce((acc, item) => {
  //       const price = parseFloat(item.variant_price) || 0;
  //       const adjustedPrice = price / 100;
  //       return acc + adjustedPrice * item.quantity;
  //     }, 0);
  //     setMerchandiseTotal(newMerchandiseTotal);
  //   } else { setMerchandiseTotal(0); }
  // }, [merchandiseItems]);

  // Use effect to get the total amounts of donations
  useEffect(() => {
    if (donationItems?.length > 0) {
      const newDonationTotal = donationItems.reduce(
        (acc, item) => acc + item.amount,
        0
      );
      setDonationTotal(newDonationTotal);
    } else {
      setDonationTotal(0);
    }
  }, [donationItems]);

  // Use effect to get the total - simplified, donations only
  useEffect(() => {
    setTotal(donationTotal);
  }, [donationTotal]);

  // Handles donation amount change
  const handleDonationChange = (donation, amount) => {
    setEditedDonation(donation);
    setUpdatedDonationAmountError("");
    setUpdatedDonationAmount(amount);
    setEditDonationsModal(true);
  };

  // Handles updating the cart with the new donation amount
  const handleUpdateDonation = () => {
    if (updatedDonationAmount <= 0 || isNaN(updatedDonationAmount)) {
      setUpdatedDonationAmountError("Please set a valid amount");
      return;
    }

    if (editedDonation && updatedDonationAmount > 0) {
      setUpdatedDonationAmountError("");

      // Update the donation amount in the cart
      dispatch(
        cartActions.updateDonationAmount({
          donation_id: editedDonation.donation_id,
          amount: updatedDonationAmount,
        })
      );
      setEditDonationsModal(false); // Close the modal after update
      window.location.reload(); // reload page to reflect the updated cart
    }
  };

  // Product change/update handlers commented out - shop feature disabled
  // const handleProductChange = (currentItem, quantity) => {
  //   setEditedProduct(currentItem);
  //   setUpdatedProduct({ ...currentItem, quantity: quantity });
  //   setUpdatedProductError("");
  //   setEditProductModal(true);
  // };
  // const handleUpdateProduct = () => {
  //   if (!updatedProduct.quantity || updatedProduct.quantity <= 0) {
  //     setUpdatedProductError("Please set a valid quantity.");
  //     return;
  //   }
  //   try {
  //     dispatch(cartActions.updateProductQuantity({
  //       product_id: editedProduct.product_id,
  //       quantity: updatedProduct.quantity,
  //       product_size: updatedProduct?.product_size,
  //       product_color: updatedProduct?.product_color,
  //     }));
  //     setEditProductModal(false);
  //     window.location.reload();
  //   } catch (error) { console.error("Can't update product."); }
  // };

  // Deletes donation from cart (product branch commented out - shop feature disabled)
  const handleDelete = (product, donation_id) => {
    try {
      // Product removal commented out - shop feature disabled
      // if (product) {
      //   dispatch(cartActions.removeProductFromCart({
      //     product_id: product.product_id,
      //     product_size: product?.product_size,
      //     product_color: product?.product_color,
      //   }));
      // } else
      if (donation_id) {
        dispatch(
          cartActions.removeDonationFromCart({ donation_id: donation_id })
        );
      }

      window.location.reload();
    } catch (error) {
      console.error("Error removing item from cart:", error);
    }
  };

  // Carousel navigation and add to cart for related products - commented out, shop feature disabled
  // const prevRelatedSlide = () => {
  //   setCurrentRelatedSlide((prev) => Math.max(prev - 1, 0));
  // };
  // const nextRelatedSlide = () => {
  //   const maxSlides = Math.ceil(relatedProducts.length / 4) - 1;
  //   setCurrentRelatedSlide((prev) => Math.min(prev + 1, maxSlides));
  // };
  // const handleAddToCart = (product) => { ... };
  // const closeModal = () => { setShowModal(false); };

  return (
    <div className="mb-16 sm:grow">
      {isLoading ? (
        <div className="flex flex-row mx-auto mt-16 w-full pb-24 justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {/* Orange banner for login prompt */}
          {!localUserData && (
            <div
              className="w-full bg-orange text-white py-3 px-4 text-center"
              style={{ paddingTop: "100px" }}
            >
              <span>Login to start purchasing! </span>
              <button
                onClick={() => openLoginSignupModal("login")}
                className="underline hover:no-underline cursor-pointer font-semibold"
              >
                Login
              </button>
              <span> Don't have an account? </span>
              <button
                onClick={() => openLoginSignupModal("signup")}
                className="underline hover:no-underline cursor-pointer font-semibold"
              >
                Sign Up
              </button>
            </div>
          )}

          {/* Shopping Cart Title Banner */}
          <div
            className="w-full bg-blue text-white text-center flex items-center justify-center"
            style={{
              paddingTop: localUserData ? "140px" : "40px",
              paddingBottom: "48px",
              minHeight: localUserData ? "200px" : "120px",
            }}
          >
            <h1 className="text-4xl font-light font-inter">Shopping Cart</h1>
          </div>

          <div
            className="flex flex-col sm:flex-row mt-2 w-full gap-20 px-4 sm:px-16"
            style={{ paddingTop: "20px" }}
          >
            {/* Left side with Donations (product sections commented out - shop feature disabled) */}
            <div className={`flex flex-col w-full sm:w-[60%] gap-9 `}>
              {/* Pet Products Section - commented out, shop feature disabled */}
              {/* <PetProductItems
                petProductItems={petProductItems}
                handleProductChange={handleProductChange}
                handleDelete={handleDelete}
                petProductTotal={petProductTotal}
              /> */}

              {/* Merchandise Section - commented out, shop feature disabled */}
              {/* <MerchandiseItems
                merchandiseItems={merchandiseItems}
                handleProductChange={handleProductChange}
                handleDelete={handleDelete}
                merchandiseTotal={merchandiseTotal}
              /> */}

              {/* Donations Section */}
              <DonationItems
                donationItems={donationItems}
                handleDonationChange={handleDonationChange}
                handleDelete={handleDelete}
                donationTotal={donationTotal}
              />
            </div>

            {/* Right side with OrderSummary and CheckoutBox */}
            <div className="w-full sm:w-[40%] flex flex-col gap-9">
              <OrderSummary
                productItems={null}
                donationItems={donationItems}
                donationTotal={donationTotal}
                productTotal={0}
                petProductTotal={0}
                merchandiseTotal={0}
                shippingFee={shippingFee}
                total={total}
              />

              <CheckoutBox
                total={total}
                productTotal={0}
                donationTotal={donationTotal}
                localUserData={localUserData}
                productItems={null}
                donationItems={donationItems}
              />
            </div>
          </div>

          {/* You May Also Like Section - commented out, shop feature disabled */}
          {/* {relatedProducts.length > 0 && (
            <div className="mt-16 py-16 bg-white px-4 sm:px-16">
              <div className="max-w-7xl mx-auto">
                <h2 className="text-3xl font-bold text-orange text-center mb-12 font-inter">
                  You May Also Like
                </h2>
                ...
              </div>
            </div>
          )} */}
        </>
      )}

      {/* Edit Donation Modal */}
      {editDonationsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
          <EditDonationModal
            editedDonation={editedDonation}
            updatedDonationAmount={updatedDonationAmount}
            updatedDonationAmountError={updatedDonationAmountError}
            setEditDonationsModal={setEditDonationsModal}
            handleUpdateDonation={handleUpdateDonation}
            handleDonationChange={handleDonationChange}
          />
        </div>
      )}

      {/* Edit Product Modal - commented out, shop feature disabled */}
      {/* {editProductModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-4">
          <EditProductModal
            editedProduct={editedProduct}
            updatedProduct={updatedProduct}
            updatedProductError={updatedProductError}
            handleUpdateProduct={handleUpdateProduct}
            handleProductChange={handleProductChange}
            setEditProductModal={setEditProductModal}
          />
        </div>
      )} */}

      {/* Product SuccessModal - commented out, shop feature disabled */}
      {/* {showModal && (
        <SuccessModal
          message="Product added to cart!"
          onClose={closeModal}
          showModal={showModal}
        />
      )} */}
    </div>
  );
}

export default Cart;
